const MicrobiomeIllustration = () => (
  <svg
    width='66'
    height='66'
    viewBox='0 0 66 66'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    {' '}
    <g id='Group 1256'>
      {' '}
      <g id='Group 417'>
        {' '}
        <path
          id='Vector'
          fillRule='evenodd'
          clipRule='evenodd'
          d='M64.9999 32.7452C64.9999 50.4176 50.6726 64.7451 33 64.7451C15.3275 64.7451 1 50.4176 1 32.7452C1 15.0704 15.3275 0.745117 33 0.745117C50.6726 0.745117 64.9999 15.0704 64.9999 32.7452Z'
          stroke='#1C3A13'
        />{' '}
      </g>{' '}
      <g id='Group 1247'>
        {' '}
        <path
          id='Vector 1'
          d='M31.7082 7.14508C31.0638 10.6537 29.3728 15.015 26.8211 17.5666C25.6419 18.7459 24.1966 20.1418 23.4066 21.5637C23.0743 22.1619 21.6585 25.3995 22.6784 24.0396'
          stroke='#1C3A13'
          stroke-linecap='round'
        />{' '}
        <path
          id='Vector 2'
          d='M27.355 17.064C29.471 16.7722 33.9676 16.7885 36.7228 13.7578'
          stroke='#1C3A13'
          stroke-linecap='round'
        />{' '}
        <path
          id='Vector 3'
          d='M40.7373 7.43634C42.7127 10.0702 46.2018 12.7011 49.3464 13.8446C51.0155 14.4516 52.6467 16.0815 54.007 17.1944C55.205 18.1746 56.2705 19.3729 56.758 20.8354'
          stroke='#1C3A13'
          stroke-linecap='round'
        />{' '}
        <path
          id='Vector 4'
          d='M47.146 13.262C44.1121 14.943 40.9182 15.7632 38.1162 17.6312'
          stroke='#1C3A13'
          stroke-linecap='round'
        />{' '}
        <path
          id='Vector 5'
          d='M46.8549 19.379C45.6725 21.3989 42.2554 25.5009 39.508 24.6869C38.0153 24.2446 35.6923 24.1531 34.1031 24.0396C33.2413 23.978 32.4762 23.7483 31.5786 23.7483'
          stroke='#1C3A13'
          stroke-linecap='round'
        />{' '}
        <path
          id='Vector 6'
          d='M40.5801 25.0541C44.2001 28.9051 47.0801 28.5851 48.8946 28.1176'
          stroke='#1C3A13'
          stroke-linecap='round'
        />{' '}
        <path
          id='Vector 7'
          d='M51.5161 21.1266C52.8836 24.5051 54.9052 27.527 55.8692 30.9009C56.7617 34.0248 56.1767 43.8916 56.1767 40.6427'
          stroke='#1C3A13'
          stroke-linecap='round'
        />{' '}
        <path
          id='Vector 9'
          d='M49.5488 39.5888C49.4185 40.3127 49.4453 41.0569 49.284 41.7738C49.1765 42.2519 48.9671 42.7014 48.8849 43.1856C48.7725 43.8475 48.7168 44.4767 48.7168 45.152C48.7168 45.6338 48.7556 46.0566 48.9269 46.5134C49.0409 46.8174 49.2175 47.0934 49.242 47.4252C49.2983 48.1848 49.5686 48.9094 49.4563 49.6816C49.1985 51.4541 48.9853 53.2096 48.5277 54.938C48.3813 55.4913 48.2209 56.2585 47.847 56.7154C47.7042 56.89 47.5636 57.0755 47.4479 57.27C47.3795 57.3849 47.3536 57.7352 47.2798 57.5137'
          stroke='#1C3A13'
          stroke-linecap='round'
        />{' '}
        <path
          id='Vector 10'
          d='M49.3975 48.2866C50.7679 47.9917 52.1499 48.0597 53.5446 48.0597C54.1574 48.0597 54.7796 47.896 55.3808 47.7908C56.2221 47.6436 56.9408 47.5531 57.4901 46.8664C57.6087 46.7182 57.8748 46.3926 58.0196 46.3202'
          stroke='#1C3A13'
          stroke-linecap='round'
        />{' '}
        <path
          id='Vector 11'
          d='M44.3301 50.0262C43.7786 50.9866 43.4905 51.9995 43.0023 52.9759C42.6819 53.6168 42.1109 54.2119 41.6073 54.7154C40.1361 56.1866 38.2444 57.0732 36.582 58.2701C35.7948 58.8369 34.8683 59.1909 33.8928 59.2702C33.3727 59.3124 32.886 59.3574 32.3802 59.4803C32.0343 59.5642 31.6588 59.4896 31.3255 59.5937C30.9073 59.7244 30.4355 59.4046 30.0188 59.4046C29.8419 59.4046 29.2823 59.4864 29.2036 59.329'
          stroke='#1C3A13'
          stroke-linecap='round'
          stroke-dasharray='2 6'
        />{' '}
        <path
          id='Vector 13'
          d='M29.8848 39.362C30.1003 39.9846 30.4092 40.554 30.6075 41.1771C30.7314 41.5665 30.8988 41.9787 31.1117 42.3284C31.5191 42.9977 31.9907 43.6116 32.4983 44.2067C33.0036 44.799 33.6072 44.9943 34.2126 45.4294C35.2501 46.175 36.1092 46.8015 37.3976 47.0681C38.3569 47.2666 39.3375 47.2996 40.3052 47.4378C41.1357 47.5565 42.0882 47.6475 42.8936 47.379'
          stroke='#1C3A13'
          stroke-linecap='round'
        />{' '}
        <path
          id='Vector 15'
          d='M31.8511 34.6727C33.1294 35.1536 34.5919 35.5976 35.7083 36.4123C36.2925 36.8386 36.9104 37.1972 37.5235 37.5804C38.7678 38.3581 39.9709 39.2678 41.1497 40.1519C41.5975 40.4877 42.0619 40.7616 42.4396 41.1813C42.8003 41.5821 42.9813 42.089 43.2884 42.5217C43.4854 42.7994 43.7353 43.0147 43.8766 43.3327C43.9302 43.4532 43.9562 43.8125 44.0279 43.5974'
          stroke='#1C3A13'
          stroke-linecap='round'
        />{' '}
        <path
          id='Vector 16'
          d='M39.2026 38.0037C40.7087 37.2314 41.4871 36.7866 42.289 35.24C42.5782 34.6823 42.857 34.1463 43.3899 33.8072C43.7656 33.568 45.4041 33.1661 45.8152 33.0443'
          stroke='#1C3A13'
          stroke-linecap='round'
        />{' '}
        <path
          id='Vector 17'
          d='M32.9857 28.8491C31.4931 28.8491 30.0116 28.9442 28.5234 29.0003C27.5673 29.0364 26.6288 29.1516 25.6661 29.1516C24.2892 29.1516 22.9554 28.8532 21.6114 28.5844C20.7386 28.4098 19.9086 27.8028 19.1113 27.4163C18.5298 27.1343 17.9678 26.8497 17.4012 26.5381C16.5893 26.0915 15.6229 25.6725 14.6826 25.6725'
          stroke='#1C3A13'
          stroke-linecap='round'
        />{' '}
        <path
          id='Vector 18'
          d='M21.4888 28.6979C23.7828 29.115 24.8513 30.9197 25.5351 32.9711C25.8793 34.0038 26.3378 35.5358 27.3125 36.1855'
          stroke='#1C3A13'
          stroke-linecap='round'
        />{' '}
        <g id='Group 2608584'>
          {' '}
          <path
            id='Vector 19'
            d='M21.3376 44.4629C21.047 46.1417 20.8838 47.9031 20.8838 49.6059C20.8838 50.2788 20.9101 50.9454 20.9636 51.6143C21.0208 52.3289 21.4067 52.8131 21.7578 53.3875C22.0174 53.8124 22.9008 54.2344 23.3629 54.3707C23.8613 54.5178 24.3872 54.6546 24.9091 54.6733C25.7967 54.7049 28.2582 55.8267 27.4638 55.4296'
            stroke='#1C3A13'
            stroke-linecap='round'
          />{' '}
          <path
            id='Vector 20'
            d='M21.1117 52.4044C19.8041 52.0162 18.4874 51.4072 17.2544 50.8161C16.839 50.6169 16.3827 50.5471 15.9603 50.3623C15.611 50.2095 15.1812 49.9462 14.7964 49.9127C14.5351 49.89 14.2643 49.9085 14.0022 49.9085C13.664 49.9085 13.2743 49.789 12.9476 49.8707C12.7005 49.9325 12.4101 49.99 12.2627 50.211'
            stroke='#1C3A13'
            stroke-linecap='round'
          />{' '}
          <path
            id='Vector 21'
            d='M27.9998 50.1143C29.3447 50.342 30.7252 50.7876 32.0205 51.2258C32.4569 51.3734 32.9183 51.3877 33.3599 51.5202C33.7251 51.6297 34.1835 51.8393 34.5696 51.8261C34.8316 51.8171 35.0983 51.7661 35.3584 51.7345C35.6942 51.6937 36.0955 51.7653 36.4099 51.6448C36.6477 51.5537 36.9291 51.4616 37.0488 51.2243'
            stroke='#1C3A13'
            stroke-linecap='round'
          />{' '}
        </g>{' '}
        <path
          id='Vector 21_2'
          d='M27.0791 41.8058C26.2804 40.213 24.908 39.0248 23.6955 37.7606C23.3248 37.374 23.0161 36.9904 22.5148 36.7613C22.1686 36.6032 21.8184 36.4851 21.4702 36.3347C20.9874 36.1261 20.4667 35.9628 20.0225 36.3086C19.4714 36.7375 18.9349 37.0712 18.4639 37.598C17.9278 38.1977 17.4502 38.8453 16.9184 39.4401C16.3742 40.0488 15.8049 40.6367 15.3324 41.3024C14.9519 41.8384 14.4092 42.1775 14.2818 42.8431'
          stroke='#1C3A13'
          stroke-linecap='round'
        />{' '}
        <path
          id='Vector 23'
          d='M8.55591 24.4623C8.66064 25.0384 8.71449 25.6332 8.70717 26.2187C8.69933 26.8458 8.47585 27.4409 8.37103 28.0549C8.19755 29.071 7.96518 30.1619 7.95085 31.1936C7.92586 32.9924 7.79958 34.7734 7.79958 36.5804C7.79958 38.2984 7.71082 39.9655 8.16094 41.6309C8.31603 42.2048 8.57719 42.7931 9.05172 43.1814C9.16522 43.2743 9.43443 43.4859 9.57695 43.5175C9.7587 43.5579 9.63398 43.5397 9.69039 43.3705'
          stroke='#1C3A13'
          stroke-linecap='round'
        />{' '}
        <path
          id='Vector 24'
          d='M8.10254 35.1267C8.98471 34.4249 9.74202 33.5798 10.5984 32.8745C11.2709 32.3207 11.7957 31.8689 12.6405 31.5551C13.6458 31.1817 14.8124 31.1181 15.8759 31.1181C16.4256 31.1181 17.0753 31.1662 17.481 31.5719'
          stroke='#1C3A13'
          stroke-linecap='round'
        />{' '}
        <path
          id='Vector 25'
          d='M23.8346 8.05008C23.053 8.53713 22.3007 9.0545 21.4479 9.41146C20.6394 9.74993 19.8829 10.0971 19.1495 10.5796C17.8203 11.4541 16.4765 12.3058 15.1536 13.1931C13.4184 14.3569 11.8524 15.6609 10.4518 17.2016C10.1366 17.5483 10.0094 17.9677 9.90137 18.4117'
          stroke='#1C3A13'
          stroke-linecap='round'
          stroke-dasharray='2 8'
        />{' '}
      </g>{' '}
    </g>{' '}
  </svg>
);

export default MicrobiomeIllustration;
